<template>
    <el-row class="mg-b5">
        <el-card class="box-card">
            <div slot="header" class="clearfix" style="display: flex;justify-content: space-between;">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item class="my-form-item">
                        <el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
                            v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
                            style="width: 200px" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-input size="mini" placeholder="请输入单号、发票号、询价单号、供应商" clearable v-model="quertInfo.objMap.xjdh"
                            style="width: 330px" prefix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-button size="mini" type="primary" @click="onSearch" >查询</el-button>
                    </el-form-item>
                </el-form>
                <div>
                    <!-- <el-button size="mini" v-if="checkRole('gys_role')" v-show="pageFlag=='all'|| pageFlag=='waita'"  type="primary" @click="addSendOrder"> 新增送货单 </el-button> -->
                </div>
            </div>
            <div class="order-table">
                <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="count>0?PAGESIZE.h-290:PAGESIZE.h-258">
                    <el-table-column prop="orderState" label="发票状态" :formatter="formatStatus"></el-table-column>
                    <el-table-column prop="orderCode" label="单号"></el-table-column>
                    <el-table-column prop="billCode" label="发票号"></el-table-column>
                    <el-table-column prop="billDate" label="制单日期"></el-table-column>
                    <el-table-column prop="gysName" label="供应商"></el-table-column>
                    <el-table-column prop="amout" label="价税合计"></el-table-column>
                    <el-table-column label="操作" align="left" width="150px" fixed="right">
                        <template slot-scope="scope">
                            <router-link :to="{path:`/semtinfo/${scope.row.id}`}">发票详情</router-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row type="flex" justify="end" class="mg-t5">
                    <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
                        :limit.sync="quertInfo.limit" :total="count">
                    </pagination>
                </el-row>
            </div>
        </el-card>
    </el-row>
</template>

<script>
import { getInvoiceList } from '@/api/semt/index.js'
export default {
    props: ['pageFlag'],
    components: {},
    data() {
        return {
            loading:false,
            tableData:[],
            count:0,
            quertInfo: {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    keyword: '',
                    // state:1,		 //采购员部分  待发布： 0，确认中 1 已签收2 已入库 3 已开票 4,
                }
            },
        };
    },
    computed: {
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        currencyInfo:function(){
            return this.$store.getters['app/currencyInfo'];
        },
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
    },
    created() {

    },
    methods: {
        onPagination: function(val) {
            this.quertInfo.page = val.page;
            this.quertInfo.limit = val.limit;
            this.getList();
        },
        tableInit(){
            console.log('获取数据')
            console.log(this.pageFlag)
            this.tableData = [];
            this.count = 0;
            this.onSearch()
        },
        onSearch(){
            this.quertInfo.page = 1;
            this.getList();
        },
        async getList(){
            let _this = this;
            _this.loading = true;
            const { data: res } = await getInvoiceList(_this.quertInfo)
            _this.loading = false
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.tableData.forEach((item)=>{
                    item['gysName'] = item.supplierInfo.name;
                })
                _this.count = res.count;
            }
        },
        formatStatus(row){

        },
    },
    mounted() {

    },
    watch: {
        'pageFlag':function(nVal){
            this.tableData=[];
            this.count=0;
            this.quertInfo= {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    keyword: '',
                }
            };
            if(nVal){
                this.tableInit()
            }
        },
    },
};
</script>

<style lang="scss">

</style>
